import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy, Timestamp, writeBatch, doc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoSearch, IoWalletOutline } from 'react-icons/io5';
import moment from 'moment';
import './CrearCargoScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';


function CrearCargoScreen() {
  const navigate = useNavigate();
  const { userData } = useAuth();

  const [residentes, setResidentes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Estados del formulario
  const [residenteId, setResidenteId] = useState('');
  const [aplicarATodos, setAplicarATodos] = useState(false);
  const [tipo, setTipo] = useState('Cuota Ordinaria');
  const [descripcion, setDescripcion] = useState('');
  const [monto, setMonto] = useState(0);
  
  // Modal de éxito
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);

  // NUEVO: Busqueda
  const [searchTerm, setSearchTerm] = useState('');

  // FECHAS
  const [fechaCreacion, setFechaCreacion] = useState(moment().format('YYYY-MM-DD'));
  const [fechaVencimiento, setFechaVencimiento] = useState(moment().format('YYYY-MM-DD'));

  // Suggestion visibility state
  const [showSuggestions, setShowSuggestions] = useState(false);

  // 1. Cargar la lista de residentes
  useEffect(() => {
    if (!userData?.condominioId) return;

    const q = query(
      collection(db, "usuarios"),
      where("condominioId", "==", userData.condominioId),
      orderBy("nombre", "asc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaResidentes = snapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(res => res.rol !== 'admin' && res.rol !== 'vigilante');
      setResidentes(listaResidentes);
    }, (error) => {
      console.error("Error al cargar residentes: ", error);
      setError("No se pudo cargar la lista de residentes.");
    });

    return () => unsubscribe();
  }, [userData]);


  // Filter Residents
  const filteredResidentes = residents => {
    if (!searchTerm) return residents;
    const lowerTerm = searchTerm.toLowerCase();
    return residents.filter(r =>
      r.nombre.toLowerCase().includes(lowerTerm) ||
      (r.numeroCasa && r.numeroCasa.toLowerCase().includes(lowerTerm))
    );
  };
  const residentesFiltrados = filteredResidentes(residentes);


  // --- LÓGICA DE GUARDADO ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones
    if (!aplicarATodos && !residenteId) {
      setError("Debes seleccionar un residente o marcar 'Aplicar a todos'.");
      return;
    }
    if (!tipo || monto <= 0) {
      setError("Tipo y Monto (mayor a 0) son obligatorios.");
      return;
    }
    if (!fechaVencimiento) {
      setError("La Fecha de Vencimiento es obligatoria.");
      return;
    }

    setLoading(true);
    setError('');

    try {
      const datosCargoBase = {
        condominioId: userData.condominioId,
        tipo: tipo,
        descripcion: descripcion,
        monto: Number(monto),
        estatus: "pendiente",
        fechaPago: null,
      };

      const batch = writeBatch(db);
      let count = 0; // eslint-disable-line no-unused-vars

      const addToBatch = (data) => {
        const ref = doc(collection(db, "cargos"));
        batch.set(ref, data);
        count++;
      };

      let targets = [];
      if (aplicarATodos) {
        const casasMap = new Map();
        residentes.forEach(res => {
          if (res.numeroCasa && res.numeroCasa !== 'N/A') {
            if (!casasMap.has(res.numeroCasa)) {
              casasMap.set(res.numeroCasa, res);
            } else if (res.tipoResidente && res.tipoResidente.toLowerCase() === 'propietario') {
               // Priorizar al Propietario como titular del cargo representativo
              casasMap.set(res.numeroCasa, res);
            }
          } else {
            targets.push(res);
          }
        });
        targets = [...targets, ...casasMap.values()];
      } else {
        targets = [residentes.find(r => r.id === residenteId)].filter(Boolean);
      }

      if (targets.length === 0) {
        setError("No hay residentes destinatarios.");
        setLoading(false);
        return;
      }

      targets.forEach(residente => {
        addToBatch({
          ...datosCargoBase,
          residenteId: residente.id,
          nombreResidente: residente.nombre,
          unidadResidente: residente.numeroCasa || 'N/A',
          fechaCreacion: Timestamp.fromDate(new Date(fechaCreacion + 'T12:00:00')), // Noon to avoid timezone shifts
          fechaVencimiento: Timestamp.fromDate(new Date(fechaVencimiento + 'T12:00:00'))
        });
      });

      await batch.commit();

      setSuccessCount(targets.length);
      setShowSuccessModal(true);

    } catch (e) {
      console.error("Error al crear cargo: ", e);
      setError("Error al guardar el cargo: " + e.message);
      setLoading(false);
    }
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/gestion-cuotas" />
      
      <main className="ks-main">
        <KondoBrandHeader title="Administración" showBackButton={false} />
        
        <div className="ks-scroll-area">
          <div className="crear-cargo-container">
      {/* Premium Header Banner */}
      <div style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', position: 'relative', overflow: 'hidden', padding: '25px', borderRadius: '15px', marginBottom: '30px', boxShadow: '0 8px 20px rgba(37, 99, 235, 0.25)' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', zIndex: 2, position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <button onClick={() => navigate('/gestion-cuotas')} style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(5px)', border: 'none', borderRadius: '50%', width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s', color: 'white', flexShrink: 0 }}>
                      <IoArrowBack size={22} />
                  </button>
                  <div style={{ marginTop: '0' }}>
                      <h1 style={{ color: 'white', margin: '0 0 5px', fontSize: '1.6rem', fontWeight: '800' }}>
                          Crear Nuevo Cargo
                      </h1>
                      <p style={{ color: 'rgba(255, 255, 255, 0.9)', margin: 0, fontSize: '0.9rem', fontWeight: '500' }}>
                          Genera cobros individuales o masivos.
                      </p>
                  </div>
              </div>
          </div>
          <div style={{ position: 'absolute', right: '-15px', bottom: '-40px', zIndex: 0, pointerEvents: 'none', transform: 'rotate(-10deg)', opacity: 0.15 }}>
              <IoWalletOutline size={150} color="white" />
          </div>
      </div>

      <div className="cc-form-wrapper">
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
          {error && <div style={{ color: '#ef4444', backgroundColor: '#fee2e2', padding: '12px', borderRadius: '8px', fontSize: '0.9em' }}>{error}</div>}

          {/* --- SECCIÓN 1: FECHAS --- */}
          <div className="cc-section">
            <h4 className="cc-section-title">📅 Fechas del Cargo</h4>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <div className="cc-form-group" style={{ flex: 1, minWidth: '200px' }}>
                <label>Fecha de Creación (Emisión)</label>
                <input
                  type="date"
                  value={fechaCreacion}
                  onChange={e => setFechaCreacion(e.target.value)}
                  className="cc-input"
                  required
                />
              </div>
              <div className="cc-form-group" style={{ flex: 1, minWidth: '200px' }}>
                <label>Fecha de Vencimiento</label>
                <input
                  type="date"
                  value={fechaVencimiento}
                  onChange={e => setFechaVencimiento(e.target.value)}
                  className="cc-input"
                  required
                />
              </div>
            </div>
          </div>

          {/* --- RESIDENTE / TODOS --- */}
          <div className="cc-section">
            <div className="cc-form-group" style={{ marginBottom: '10px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={aplicarATodos}
                  onChange={(e) => setAplicarATodos(e.target.checked)}
                  style={{ width: '18px', height: '18px' }}
                />
                Aplicar a TODOS los residentes activos
              </label>
            </div>

            {!aplicarATodos && (
              <div className="cc-form-group cc-autocomplete-wrapper">
                <label>Asignar a Residente</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    placeholder="Escribe para buscar (Nombre o Unidad)..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setResidenteId('');
                      setShowSuggestions(true);
                    }}
                    onFocus={() => setShowSuggestions(true)}
                    className="cc-input"
                    style={{ paddingLeft: '40px' }}
                  />
                  <IoSearch style={{ position: 'absolute', left: '12px', top: '14px', color: '#9ca3af', fontSize: '1.1em' }} />
                </div>

                {/* Suggestions */}
                {showSuggestions && searchTerm && !residenteId && residentesFiltrados.length > 0 && (
                  <ul className="cc-suggestions-list">
                    {residentesFiltrados.map(res => (
                      <li
                        key={res.id}
                        className="cc-suggestion-item"
                        onClick={() => {
                          setResidenteId(res.id);
                          setSearchTerm(`${res.nombre} - ${res.numeroCasa || 'Sin Unidad'}`);
                          setShowSuggestions(false);
                        }}
                      >
                        <div className="cc-suggestion-name">{res.nombre}</div>
                        <div className="cc-suggestion-unit">Unidad: {res.numeroCasa || 'N/A'}</div>
                      </li>
                    ))}
                  </ul>
                )}
                {showSuggestions && searchTerm && residentesFiltrados.length === 0 && !residenteId && (
                  <div className="cc-suggestions-list" style={{ padding: '15px', color: '#64748b' }}>
                    No se encontraron resultados
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="cc-form-group">
            <label>Tipo de Cargo</label>
            <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="cc-select" required>
              <option value="Cuota Ordinaria">Cuota Ordinaria</option>
              <option value="Cuota Extraordinaria">Cuota Extraordinaria</option>
              <option value="Multa">Multa</option>
              <option value="Intereses">Intereses</option>
              <option value="Otro">Otro</option>
            </select>
          </div>

          <div className="cc-form-group">
            <label>Descripción (Opcional)</label>
            <input
              type="text"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              className="cc-input"
              placeholder="Ej: Mantenimiento Enero 2026"
            />
          </div>

          <div className="cc-form-group">
            <label>Monto (MXN)</label>
            <input type="number" value={monto} onChange={(e) => setMonto(e.target.value)} className="cc-input" min="0.01" step="0.01" required />
          </div>

          <button type="submit" className="cc-btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : 'Crear Cargo'}
          </button>

          <button
            type="button"
            className="cc-auto-btn"
            onClick={() => navigate('/admin-cuotas/configuracion-automatica')}
          >
            ⚙️ Configurar Cuotas Automáticas (Mensual)
          </button>
        </form>
      </div>
    </div>
        </div>
      </main>
      {showSuccessModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 99999
        }}>
          <div style={{
            background: 'white', padding: '30px', borderRadius: '24px',
            width: '90%', maxWidth: '380px', textAlign: 'center',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            fontFamily: "'Inter', sans-serif"
          }}>
            <div style={{
              width: '60px', height: '60px', borderRadius: '50%',
              backgroundColor: '#e0f2fe', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', color: '#0284c7', fontSize: '28px',
              boxShadow: '0 4px 10px rgba(2, 132, 199, 0.1)'
            }}>
              ✨
            </div>
            <h3 style={{ margin: '0 0 10px', fontSize: '1.3rem', fontWeight: '800', color: '#1e293b' }}>
              ¡Cobro Generado!
            </h3>
            <p style={{ margin: '0 0 24px', fontSize: '0.95rem', color: '#64748b', lineHeight: '1.5' }}>
              El cargo ha sido creado con éxito para <strong>{successCount}</strong> {successCount === 1 ? 'residente' : 'residentes'}.
            </p>
            <button
              onClick={() => {
                setShowSuccessModal(false);
                navigate('/gestion-cuotas');
              }}
              style={{
                width: '100%', padding: '12px 24px', border: 'none',
                borderRadius: '12px', background: '#3b82f6', color: 'white',
                fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                transition: 'all 0.2s'
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
      <KondoBottomNav activeRoute="/gestion-cuotas" />
    </div>
  );
}

export default CrearCargoScreen;